// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1-TaN","amount":"Amount_amount__3Igoc","tip":"Amount_tip__3PYBB","tipHeader":"Amount_tipHeader__k71Ql","tipsWrap":"Amount_tipsWrap__3hr5j"};